import React from 'react';
import FeaturesItem from "./FeaturesItem";

function Features() {
    return (
        <div className="w-full">

            <div className="container mx-auto">

                <h2 className="py-10 md:py-16 text-2xl lg:text-5xl font-bold text-gray-800 text-center">¿Porqué Happy
                    Taxi?</h2>

                <div className="px-5 lg:px-16 pb-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 gap-y-10 ">

                    <FeaturesItem title="Marcadores"
                                  message="Guarda las direcciones que mas visitas para tenerlas de forma rapido cuando vayas a solicitar un viaje."
                                  icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                         className="w-6 h-6 text-white">
                                        <path fillRule="evenodd"
                                              d="M6.32 2.577a49.255 49.255 0 0111.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 01-1.085.67L12 18.089l-7.165 3.583A.75.75 0 013.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93z"
                                              clipRule="evenodd"/>
                                    </svg>
                                }
                    />

                    <FeaturesItem title="Respeto y seguridad"
                                  message="Estamos comprometidos con el respeto a todas las personas y su seguridad."
                                  icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                         className="w-6 h-6 text-white">
                                        <path fillRule="evenodd"
                                              d="M12.516 2.17a.75.75 0 00-1.032 0 11.209 11.209 0 01-7.877 3.08.75.75 0 00-.722.515A12.74 12.74 0 002.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 00.374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 00-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08zm3.094 8.016a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                                              clipRule="evenodd"/>
                                    </svg>
                                }
                    />

                    <FeaturesItem title="Facturación transparente"
                                  message="Clientes y conductores recibirán facturas de pago detalladas."
                                  icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                         className="w-6 h-6 text-white">
                                        <path d="M4.5 3.75a3 3 0 00-3 3v.75h21v-.75a3 3 0 00-3-3h-15z"/>
                                        <path fillRule="evenodd"
                                              d="M22.5 9.75h-21v7.5a3 3 0 003 3h15a3 3 0 003-3v-7.5zm-18 3.75a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z"
                                              clipRule="evenodd"/>
                                    </svg>
                                }
                    />



                    <FeaturesItem title="Atención personalizada"
                                  message="Encontrarás autos para todos los gustos y necesidades. Estaremos atentos a todos tus comentarios y experiencias."
                                  icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                         className="w-6 h-6 text-white">
                                        <path fillRule="evenodd"
                                              d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                                              clipRule="evenodd"/>
                                    </svg>
                                }
                    />

                    <FeaturesItem title="Consumo de datos"
                                  message="Mantenemos un bajo consumo de datos mientras usas el servicio."
                                  icon={
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                           className="w-6 h-6 text-white">
                                          <path
                                              d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375z"/>
                                          <path fillRule="evenodd"
                                                d="M3.087 9l.54 9.176A3 3 0 006.62 21h10.757a3 3 0 002.995-2.824L20.913 9H3.087zM12 10.5a.75.75 0 01.75.75v4.94l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72v-4.94a.75.75 0 01.75-.75z"
                                                clipRule="evenodd"/>
                                      </svg>
                                  }
                    />

                    <FeaturesItem title="Confidencialidad y privacidad"
                                  message="Tu información personal es privada. En Happy procuramos el manejo cuidadoso de datos confidenciales."
                                  icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                         className="w-6 h-6 text-white">
                                        <path fillRule="evenodd"
                                              d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                                              clipRule="evenodd"/>
                                    </svg>
                                }
                    />

                </div>

            </div>

        </div>
    );
}

export default Features;